import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import DashboardMapView from '../../components/Dashboard/DashboardMapView';

const MapView = () => {
  return (
    <Box sx={{ 
      height: '100vh', 
      width: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <Paper 
        elevation={1} 
        sx={{ 
          p: { xs: 2, md: 3 }, 
          borderRadius: 0,
          borderBottom: '1px solid #e0e0e0',
          flexShrink: 0
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ 
            color: 'primary.main', 
            fontWeight: 'bold',
            fontSize: { xs: '1.5rem', md: '2rem' }
          }}
        >
          Map View
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            mt: 0.5,
            fontSize: { xs: '0.9rem', md: '1rem' }
          }}
        >
          View and monitor all bins and workers in real-time
        </Typography>
      </Paper>
      
      {/* Map Container - Takes remaining space */}
      <Box sx={{ 
        flex: 1, 
        width: '100%', 
        overflow: 'hidden',
        position: 'relative'
      }}>
        <DashboardMapView />
      </Box>
    </Box>
  );
};

export default MapView; 